import { useSelector } from 'react-redux';
import { ICourse } from '@CT-Types/course';
import { getCourseSelected, getIsLoadingCourses, selectors } from './courseReducer';

/**
 * Whether the courses slice currently has a fetch in flight. Lets callers tell "no course
 * yet" apart from "this course genuinely has no detail", which reading the course alone
 * cannot express.
 */
export const useIsLoadingCourses = (): boolean =>
  useSelector(getIsLoadingCourses) as boolean;

// eslint-disable-next-line import/prefer-default-export
export const useCurrentCourse = (): ICourse => {
  const currentCourseId = useSelector(getCourseSelected);
  const currentCourse = useSelector((state) =>
    selectors.getCourseDetailById(
      state as {
        courses: any;
      },
      currentCourseId,
    ),
  );
  return currentCourse;
};
export const useCourseById = (id: number) => {
  const currentCourse = useSelector((state) =>
    selectors.getCourseDetailById(
      state as {
        courses: any;
      },
      id,
    ),
  );
  return currentCourse;
};
